export default __webpack_public_path__ + "static/home_hero_mobile-42e5f4fd6fc961c9e4824c2939e4bfb6.png";